<template>
  <div>

<!--    入场&退场-->
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div style="height: 50px;padding-top: 5px;">
          <transition
              appear
              name="animate__animated animate__bounce"
              enter-active-class="animate__bounceInLeft"
              leave-active-class="animate__bounceOutRight"
          >
            <ComeIn v-if="isEdit"/>
          </transition>
        </div>
      </el-col>
    </el-row>

<!--    轮播图-->
    <AutoCut/>

<!--    不忘初心-->
      <InitialHeart/>

<!--    欢迎词-->
      <MyWelcome/>

<!--    下载区-->
      <DownloadArea/>

<!--    结语-->
    <MyEpilogue/>

  </div>
</template>

<script>
import 'animate.css';
import AutoCut from "@/components/index/part/AutoCut";
import InitialHeart from "@/components/index/part/InitialHeart";
import ComeIn from "@/components/index/part/ComeIn";
import MyWelcome from "@/components/index/part/MyWelcome";
import DownloadArea from "@/components/index/part/DownloadArea";
import MyEpilogue from "@/components/index/part/MyEpilogue";
export default {
  name: "ClemIndex",
  components: {MyEpilogue, DownloadArea, MyWelcome, ComeIn, InitialHeart, AutoCut},
  data (){
    return {
      // 入场欢迎 第三方animate过度动画
      isEdit: true
    }
  },
  mounted() {
    setTimeout(()=>{
      this.isEdit = false;
    },3000);
  },
  //路由组件专属激活钩子
  activated() {
    //修改所在高亮
    this.$store.commit('updateIndexColor','#000000');

    //定位到顶部
    window.scroll(0, 0);
  },
  //路由组件专属失活钩子
  deactivated() {
    this.$store.commit('updateIndexColor','');
  }
}
</script>

<style scoped>

</style>
